export default __webpack_public_path__ + "static/media/What-is-a-Factory-of-the-future-Infographic.0a7fa10c.svg";